@if (!isLoading) {
  <div class="card">
    <div class="header">
      <mat-icon>assignment</mat-icon>
      <p>Scope of work form</p>
    </div>
    <span
      >Select the form to be used by the inspector and enable/disable
      sections</span
    >
    <div class="main-container">
      <div class="form-selector-container">
        <mat-form-field appearance="outline">
          <mat-label>Scope of Work From</mat-label>
          <mat-select
            [(ngModel)]="defaultFormId"
            [disabled]="
              config?.allowFormSelect == null ||
              config?.allowFormSelect == false
            "
            (selectionChange)="onSowFormChanged($event)"
          >
            <mat-option [value]=""></mat-option>
            @for (screen of sowScreens; track screen) {
              <mat-option [value]="screen.id">
                {{ screen.fullName }}</mat-option
              >
            }
          </mat-select>
        </mat-form-field>
      </div>
      <div class="sections-selector-container">
        @if (!isLoadingSections) {
          @for (section of toggleSections; track section) {
            <div class="toggle-selector">
              <mat-slide-toggle
                [(ngModel)]="section.selected"
                (change)="onToggleChanged(section)"
                >{{ section.name }}</mat-slide-toggle
              >
            </div>
          }
        }
        @if (isLoadingSections) {
          <mat-spinner diameter="32"></mat-spinner>
        }
      </div>
    </div>
  </div>
}

@if (isLoading) {
  <mat-spinner diameter="32"></mat-spinner>
}
